import { ArrowUpRight } from "lucide-react";
import { NICHES } from "../../lib/constants";
import { trackEvent } from "../../lib/api";

export default function Niches() {
  const scrollToForm = (typeKey, title) => {
    trackEvent("niche_cta_click", { niche: typeKey });
    const el = document.getElementById("cotiza");
    if (el) {
      window.dispatchEvent(new CustomEvent("vt:preselectProjectType", { detail: { typeKey, title } }));
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section data-testid="niches-section" className="bg-white text-[#1F2937] section-pad">
      <div className="container-tight">
        <div className="flex items-center gap-3 mb-4">
          <span className="divider-accent" />
          <span className="kicker">Industrias</span>
        </div>
        <h2 className="font-display font-black tracking-tightest text-4xl md:text-5xl lg:text-6xl max-w-3xl">
          Velarias Tens para <span className="text-accent">cada industria</span>.
        </h2>
        <p className="mt-6 max-w-2xl text-[#1F2937]/70 text-base md:text-lg">
          Soluciones especializadas según el uso del espacio.
        </p>

        <div className="mt-16 grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {NICHES.map((n) => (
            <button
              key={n.id}
              type="button"
              onClick={() => scrollToForm(n.projectTypeKey, n.title)}
              className="group relative overflow-hidden text-left border border-[#DDE2D5] hover:border-accent transition-colors"
              data-testid={`niche-${n.id}`}
            >
              <div className="relative aspect-[4/5] img-zoom-wrap">
                <img src={n.img} alt={n.title} loading="lazy" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-eclipse via-eclipse/30 to-transparent" />

                {/* Hover overlay */}
                <div className="absolute inset-0 bg-accent/0 group-hover:bg-accent/90 transition-colors flex items-end p-6 opacity-0 group-hover:opacity-100">
                  <span className="flex items-center gap-2 text-white font-display font-black uppercase tracking-wider text-sm">
                    Cotizar para este espacio <ArrowUpRight className="w-5 h-5" />
                  </span>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 group-hover:opacity-0 transition-opacity">
                  <h3 className="font-display font-black text-[#1F2937] text-lg md:text-xl uppercase tracking-tight leading-tight">
                    {n.title}
                  </h3>
                  <p className="mt-1 text-[#1F2937]/75 text-xs md:text-sm">{n.desc}</p>
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* Post-Nichos CTA */}
        <div className="mt-12 text-center md:text-left">
          <button
            type="button"
            onClick={() => {
              const el = document.getElementById("cotiza");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center gap-3 font-display font-black text-lg md:text-xl text-[#1F2937] group"
            data-testid="niches-bottom-cta"
          >
            ¿Tu industria no aparece? También te atendemos.
            <span className="text-accent group-hover:translate-x-1 transition-transform">Cuéntanos →</span>
          </button>
        </div>
      </div>
    </section>
  );
}
